<template>
  <div class="">
    
    <!-- 查询表单 -->
    <div style="margin-top: 20px;">
            <!-- 表格 -->
       <el-table
        :data="tableData"
        border
        style="width: 100%">
          <el-table-column
            prop="name"
            label="名称">
          </el-table-column>
          <el-table-column
            prop="value"
            label="值">
              <template slot-scope="scope">
                  <span v-if="scope.row.value.indexOf('http') === -1">{{scope.row.value}}</span>
                  <img v-else :src="scope.row.value" style="width: 170px;height: 170px;" />
              </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间">
          </el-table-column>

          <el-table-column
            label="操作">
              <template slot-scope="scope">
                <el-button @click="editormodel(scope.row)" type="text" size="small">编辑</el-button>
              </template>
          </el-table-column>
      </el-table>
      

      <!-- 分页 -->
<!--      <el-pagination style="margin-top: 20px;"-->
<!--        @size-change="handleSizeChange"-->
<!--        @current-change="handleCurrentChange"-->
<!--        :current-page="currentPage"-->
<!--        :page-sizes="[10, 20, 40, 100]"-->
<!--        :page-size="pageSize"-->
<!--        layout="total, sizes, prev, pager, next, jumper"-->
<!--        :total="tableTotal">-->
<!--      </el-pagination>-->
    </div>

    <!-- 修改或新建对话框 -->
    <el-dialog :title="dlgType === 'change' ? '编辑机型' : '新建机型'" :visible.sync="isDlg" width="700px">
      <div style="margin: 20px;">
        <div>
          <el-form ref="editModalForm" :model="editModalForm" label-width="120px">
            <el-form-item label="名称" prop="name">
              <el-input clearable v-model="editModalForm.name" disabled></el-input>
            </el-form-item>
            <el-form-item label="值" prop="value">
                <el-upload v-if="editModalForm.typeKey === 'wx_pay_qrcode' || editModalForm.typeKey === 'zfb_pay_qrcode'"
                        class="avatar-uploader"
                        action="aa"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :before-upload="handleBeforeUpload"
                        :on-change="uploadImg"
                >
                    <img v-if="editModalForm.value" :src="editModalForm.value" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              <el-input v-else clearable v-model="editModalForm.value"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button type="primary" style="margin: 30px 20px;" @click="submitEditor">确定</el-button>
          <el-button style="margin: 10px 20px;" @click="closeEditormodelDlg">暂不</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  components:{},
  props:{},
  data(){
    return {

      // 表格数据
      tableTotal: 0,
      tableData: [],
      typeKey: 'global',
      pageSize: 10,
      currentPage: 1,

      // 新建编辑对话框数据

      isDlg: false,
      editModalForm: {
        id: null,
        value: null,
        name: null,
        categoryId: '',
        typeKey: 'phoneModal',
        parentId: null,
        face: false,
        ycy: false,
      },

      dlgType: 'change',

      // 选择
      modelOptions: [],
      loading: false,

      categoryOptions: [],
      brandOptions: [],
      dlgBrandOptions: []
    }
  },
  watch:{},
  computed:{},
  methods:{
      // 分页函数
    handleSizeChange(val) {
      console.log(val);
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1)
    },
    handleCurrentChange(val) {
      this.currentPage = val

      // 重新请求表格数据
      this.getModalList()
    }, 

    // 获取表格数据
    getModalList() {
      let self  = this;
      self.$api.getLinkageTree({
        typeKey: self.typeKey,
        page: self.currentPage,
        size: self.pageSize,

      }).then(res => {
        self.tableData = res.data[0].children || [];
        console.log(self.tableData);
        self.tableTotal = res.data.total
      })
    },

    // 修改
    editormodel(row) {
      let self = this;
      self.editModalForm = {
        id: null,
        value: null,
        name: null,
        categoryId: '',
        typeKey: 'global',
        parentId: null,
        face: false,
        ycy: false,
      }

      self.dlgType = 'change'

      for(let i in self.editModalForm) {
          if(row[i])self.editModalForm[i] = row[i]
      }
      self.isDlg = true
    },
   handleSuccess(res, file) {
       console.log(res)
       console.log(file)
   },
      handleBeforeUpload(file) {
          console.log(file);
          let formData = new FormData()
          formData.append("multipartFile", file);
          this.$api.uploadImageFull(formData).then(res => {
              console.log(res);
              this.editModalForm.value = res.data;
          });
        return false;
      },
      uploadImg() {

      },
    dlgChangeCategory(typeKey, optionName, categoryId) {
      this.getSelectOptions(typeKey, optionName, categoryId)
      this.editModalForm.parentId = null
    },

    // 关闭编辑对话框
    closeEditormodelDlg() {
      this.isDlg = false
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs['editModalForm'].validate((valid) => {
        if (valid) {
          let params = {}
          for(let i in self.editModalForm) {
            if(i === 'face' || i === 'ycy') {
              params[i] = this.editModalForm[i] ? 1: 0
            } else {
              params[i] = this.editModalForm[i]
            }
          }
          if(self.dlgType === 'change') {
            self.$api.changeLinkage(params.id, params).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                self.getModalList()
                self.closeEditormodelDlg()
              }
            })
          } else {
            self.$api.addLinkage(params).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
                self.getModalList()
                self.closeEditormodelDlg()
              }
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
     
    },

    // 请求分类列表，提供编辑时选择用
    getSelectOptions(typeKey, optionName, categoryId) {
      let self = this;
      self.$api.getClass({
        categoryId: categoryId,
        typeKey: typeKey,
        page: 1,
        size: 100000,
      }).then(res => {
        if(res.code === 200) {
          self[optionName] = res.data.records
        }
      })
    },

    changeStatus(row, newStatus) {
      let self = this
      self.$api.changeLinkage(row.id, {
        name: row.name,
        status: newStatus,
        typeKey: 'phoneModal',
      }).then(res => {
        if(res.code === 200) {
          this.$message({
            message: '修改成功',
            type: 'success'
          });
          self.getModalList()
        }
      })
    },
    upDownMove(id, toIndex, type) {
      let self = this;
      self.$api.changeLinkageOrder({
        currentId: id,
        swapId: type ? toIndex: self.tableData[toIndex].id
      }).then(res => {
        if(res.code === 200) {
          this.$message({
            message: '移动成功',
            type: 'success'
          });
          self.getModalList()
        }
      })
    }
  },
  created(){},
  mounted(){
    let self = this;
    self.getModalList()
    self.getSelectOptions('category', 'categoryOptions')
  }
}
</script>
<style lang="less" scoped>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>